import { useApiClient } from 'bff/ApiClientProvider';
import { queryOptions } from '@tanstack/react-query';
import { ReportingGetBookSummaryRequest } from 'bff/client';

export const getBookSummary = (request: ReportingGetBookSummaryRequest) => {
  const { reportingApi } = useApiClient();

  return queryOptions({
    queryKey: ['BookSummary'],
    queryFn: () => reportingApi.reportingGetBookSummary(request),
    select: (response) => response?.data
  });
};
